import { gql } from '@apollo/client'

export const SEND_FEEDBACK = gql`
  mutation SendFeedback(
    $entityType: FeedbackEntityTypeEnum!
    $entityId: ID!
    $userId: ID!
    $text: String!
  ) {
    sendFeedback(
      input: { entityType: $entityType, entityId: $entityId, userId: $userId, text: $text }
    ) {
      success
      errors
    }
  }
`
